import React from 'react';
import { useTranslation } from 'react-i18next';
import daily_calendar from '../../../assets/images/daily_calendar.png';
import week_calendar from '../../../assets/images/week_calendar.png';
import month_calendar from '../../../assets/images/month_calendar.png';
import { NotificationType } from '../types';

interface ProfileStep3Props {
	selectedNotification: NotificationType;
	notificationsEnabled: boolean;
	onNotificationSelect: (notification: NotificationType) => void;
	onNotificationsEnabledChange: (enabled: boolean) => void;
}

const ProfileStep3: React.FC<ProfileStep3Props> = ({
	selectedNotification,
	notificationsEnabled,
	onNotificationSelect,
	onNotificationsEnabledChange,
}) => {
	const { t } = useTranslation();

	return (
		<div className="row text-profile__row">
			<div className="col-12 col-lg-10 mt-1">
				<div>
					<div className="rowPanel">
						<div
							className={`col-3 panel-notification ${
								selectedNotification === 'daily' ? 'panel-notification-active' : ''
							}`}
							onClick={() => onNotificationSelect('daily')}>
							<img
								alt="daily_calendar"
								src={daily_calendar}
								className="calendar-img"
							/>
							<div className={`${selectedNotification === 'daily' ? 'txt-config-active' : 'txt-config'}`}>
								{t('register.testProfile.step_3.daily')}
							</div>
						</div>
						<div
							className={`col-3 panel-notification ${
								selectedNotification === 'week' ? 'panel-notification-active' : ''
							}`}
							onClick={() => onNotificationSelect('week')}>
							<img
								alt="week_calendar-img"
								src={week_calendar}
								className="calendar-img"
							/>
							<div className={`${selectedNotification === 'week' ? 'txt-config-active' : 'txt-config'}`}>
								{t('register.testProfile.step_3.week')}
							</div>
						</div>
						<div
							className={`col-3 panel-notification ${
								selectedNotification === 'month' ? 'panel-notification-active' : ''
							}`}
							onClick={() => onNotificationSelect('month')}>
							<img
								alt="month_calendar"
								src={month_calendar}
								className="calendar-img"
							/>
							<div className={`${selectedNotification === 'month' ? 'txt-config-active' : 'txt-config'}`}>
								{t('register.testProfile.step_3.month')}
							</div>
						</div>
					</div>
					<div className="row">
						<label className="custom-checkbox-label">
							<input
								name="notificationsEnabled"
								type="checkbox"
								className="custom-checkbox-input"
								checked={!notificationsEnabled}
								onChange={(e) => onNotificationsEnabledChange(!e.target.checked)}
							/>
							<span className="custom-checkbox-indicator"></span>
							<span className="checkbox-text">{t('register.testProfile.step_3.checkbox')}</span>
						</label>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProfileStep3;
